import { isDefined, isNumberString } from "@perxis-auto/shared";
const getObjectCoordinates = (map, lat, lng) => {
  const projection = map.getProjection();
  if (!projection) {
    return null;
  }
  const scale = Math.pow(2, map.getZoom() ?? 1);
  const latLng = new google.maps.LatLng(lat, lng);
  const worldPoint = projection.fromLatLngToPoint(latLng);
  if (!worldPoint) {
    return null;
  }
  const bounds = map.getBounds();
  if (!bounds) {
    return null;
  }
  const ne = projection.fromLatLngToPoint(bounds.getNorthEast());
  const sw = projection.fromLatLngToPoint(bounds.getSouthWest());
  if (!ne || !sw) {
    return null;
  }
  const topLeft = new google.maps.Point(sw.x * scale, ne.y * scale);
  const mapOffset = map.getDiv().getBoundingClientRect();
  return {
    lat,
    lng,
    pageX: worldPoint.x * scale - topLeft.x + mapOffset.left + window.scrollX,
    pageY: worldPoint.y * scale - topLeft.y + mapOffset.top + window.scrollY
  };
};
const findPin = (pins, marker) => {
  const { text: pinId } = marker.getLabel();
  const pin = pins.find(({ id }) => id.toLowerCase() === pinId.toLowerCase());
  return pin ?? null;
};
const setMarkerIcon = (marker, iconUrl, size, offset) => {
  marker.setIcon({
    url: iconUrl,
    scaledSize: new google.maps.Size(...size),
    anchor: new google.maps.Point(-offset[0], -offset[1])
  });
};
function parseSize(value, parentSize) {
  if (!value) return 0;
  if (value.endsWith("px")) {
    return parseFloat(value);
  }
  if (value.endsWith("%")) {
    return parseFloat(value) / 100 * parentSize;
  }
  if (isNumberString(value)) {
    return parseFloat(value);
  }
  console.warn("Unsupported unit in:", value);
  return 0;
}
function normalizeOccupiedArea(area, containerSize) {
  const { top, left, bottom, right, width, height } = area;
  return {
    top: isDefined(top) && typeof top === "string" ? parseSize(top, containerSize.height) : top,
    left: isDefined(left) && typeof left === "string" ? parseSize(left, containerSize.width) : left,
    bottom: isDefined(bottom) && typeof bottom === "string" ? parseSize(bottom, containerSize.height) : bottom,
    right: isDefined(right) && typeof right === "string" ? parseSize(right, containerSize.width) : right,
    width: parseSize(width, containerSize.width),
    height: parseSize(height, containerSize.height)
  };
}
const ZONE_ANGLES = {
  topLeft: ["top", "left"],
  topRight: ["top", "right"],
  bottomRight: ["bottom", "right"],
  bottomLeft: ["bottom", "left"]
};
const calculatePadding = (areas, mapContainerSize) => {
  const result = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  };
  areas.forEach((area) => {
    if (area.width === mapContainerSize.width && area.height === mapContainerSize.height) {
      return;
    }
    if (isDefined(area.top) && isDefined(area.left)) {
      const [calcTop, calcLeft] = calculateArea(ZONE_ANGLES.topLeft, area, mapContainerSize, result);
      result.top = calcTop;
      result.left = calcLeft;
      return;
    }
    if (isDefined(area.top) && isDefined(area.right)) {
      const [calcTop, calcRight] = calculateArea(ZONE_ANGLES.topRight, area, mapContainerSize, result);
      result.top = calcTop;
      result.right = calcRight;
      return;
    }
    if (isDefined(area.bottom) && isDefined(area.right)) {
      const [calcBottom, calcRight] = calculateArea(ZONE_ANGLES.bottomRight, area, mapContainerSize, result);
      result.bottom = calcBottom;
      result.right = calcRight;
      return;
    }
    if (isDefined(area.bottom) && isDefined(area.left)) {
      const [calcBottom, calcLeft] = calculateArea(ZONE_ANGLES.bottomLeft, area, mapContainerSize, result);
      result.bottom = calcBottom;
      result.left = calcLeft;
      return;
    }
  });
  return result;
};
const calculateArea = (zoneAngle, area, mapContainerSize, value) => {
  const areaVerticalValue = area[zoneAngle[0]];
  const areaHorizontalValue = area[zoneAngle[1]];
  if (!isDefined(areaVerticalValue) || !isDefined(areaHorizontalValue)) {
    return [0, 0];
  }
  const height = Math.max(value[zoneAngle[0]], areaVerticalValue + area.height);
  const width = Math.max(value[zoneAngle[1]], areaHorizontalValue + area.width);
  const heightRatio = height / mapContainerSize.height;
  const widthRatio = width / mapContainerSize.width;
  if (width > height && widthRatio > heightRatio && heightRatio !== 1) {
    return [height, value[zoneAngle[1]]];
  }
  if (width > height && widthRatio > heightRatio && heightRatio === 1) {
    return [0, width];
  }
  if (widthRatio === 1) {
    return [height, 0];
  }
  return [value[zoneAngle[0]], width];
};
export {
  calculatePadding,
  findPin,
  getObjectCoordinates,
  normalizeOccupiedArea,
  parseSize,
  setMarkerIcon
};
//# sourceMappingURL=utils.js.map
